import React from 'react'

const ManageProductIcon = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="manageProductIcon">
      <path
        d="M24.675 6.85144L15.05 1.58285C14.7283 1.40582 14.3672 1.31299 14 1.31299C13.6328 1.31299 13.2717 1.40582 12.95 1.58285L3.325 6.85144C2.9806 7.03988 2.69325 7.31754 2.49311 7.65527C2.29297 7.99301 2.18741 8.37839 2.1875 8.77097V19.2294C2.18741 19.622 2.29297 20.0074 2.49311 20.3451C2.69325 20.6828 2.9806 20.9605 3.325 21.1489L12.95 26.4175C13.2716 26.5948 13.6328 26.6877 14 26.6877C14.3672 26.6877 14.7284 26.5948 15.05 26.4175L24.675 21.1489C25.0194 20.9605 25.3067 20.6828 25.5069 20.3451C25.707 20.0074 25.8126 19.622 25.8125 19.2294V8.77097C25.8126 8.37839 25.707 7.99301 25.5069 7.65527C25.3067 7.31754 25.0194 7.03988 24.675 6.85144ZM14 4.00004L21.875 8.31269L19.5311 9.59566L11.6561 5.2841L14 4.00004ZM14 12.6221L6.125 8.31269L8.92062 6.78144L16.7956 11.0919L14 12.6221ZM4.8125 10.5866L12.6875 14.896V23.2818L4.8125 18.9702V10.5866ZM15.3125 23.2818V14.896L17.9375 13.4599V16.6252C17.9375 16.9733 18.0758 17.3071 18.3219 17.5533C18.5681 17.7994 18.9019 17.9377 19.25 17.9377C19.5981 17.9377 19.9319 17.7994 20.1781 17.5533C20.4242 17.3071 20.5625 16.9733 20.5625 16.6252V12.0227L23.1875 10.5866V18.9702L15.3125 23.2818Z"
        fill="#EF8658"
      />
    </g>
  </svg>
)

export default ManageProductIcon
